"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;
var Icon = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  install: function install() {}
};
exports.Icon = Icon;
var _default = Icon;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vxe-table/lib/icon/index.js
// module id = dWxD
// module chunks = 141